(function () {
  function tryBind() {
    const iframe = document.querySelector('iframe.gw-modal');
    if (!iframe) return;
    let doc;
    try { doc = iframe.contentDocument || iframe.contentWindow.document; }
    catch (e) { return; }
    if (!doc || !doc.querySelector('.modal-container')) return;
    if (doc.__kbiteBound) return;
    doc.__kbiteBound = true;

    doc.addEventListener('click', function (e) {
      if (!e.target.closest('.modal-container')) {
        const closeBtn = doc.querySelector('.close-icon.action-close, .action-close');
        if (closeBtn) closeBtn.click();
      }
    }, true);
  }

  setInterval(tryBind, 400);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    const iframe = document.querySelector('iframe.gw-modal');
    if (!iframe) return;
    try {
      const doc = iframe.contentDocument || iframe.contentWindow.document;
      const closeBtn = doc && doc.querySelector('.close-icon.action-close, .action-close');
      if (closeBtn) closeBtn.click();
    } catch (e) {}
  });
})();

/* Pages de politiques (/policies/*) — Numerigram, octobre 2026.
   Charge assets/sdo-politiques.css, met les tableaux dans un cadre défilant
   et ajoute un sommaire en haut des longues pages qui n'en ont pas. Les textes ne sont pas modifiés. */
(function () {
  var c = document.querySelector('.shopify-policy__container');
  var s = document.currentScript;
  if (!c || !s) return;
  var l = document.createElement('link');
  l.rel = 'stylesheet';
  l.href = s.src.replace(/kbite-modal-close\.js(\?.*)?$/, 'sdo-politiques.css?v=pol1');
  document.head.appendChild(l);
  var b = c.querySelector('.shopify-policy__body');
  if (!b) return;
  [].forEach.call(b.querySelectorAll('table'), function (t) {
    if (t.parentNode.classList.contains('sdo-pol-table')) return;
    var w = document.createElement('div');
    w.className = 'sdo-pol-table';
    t.parentNode.insertBefore(w, t);
    w.appendChild(t);
  });
  var h = b.querySelectorAll('h2');
  if (h.length < 6 || b.querySelectorAll('a[href^="#"]').length >= 3) return;
  var en = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var nav = document.createElement('nav');
  nav.className = 'sdo-pol-sommaire';
  nav.setAttribute('aria-label', en ? 'Contents' : 'Sommaire');
  nav.innerHTML = '<p>' + (en ? 'Contents' : 'Sommaire') + '</p><ul></ul>';
  var ul = nav.querySelector('ul');
  [].forEach.call(h, function (x, i) {
    if (!x.id) x.id = 'section-' + (i + 1);
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + x.id;
    a.textContent = x.textContent.replace(/\s+/g, ' ').trim();
    li.appendChild(a);
    ul.appendChild(li);
  });
  h[0].parentNode.insertBefore(nav, h[0]);
})();

/* Case newsletter de la modale Kbite (retour en stock) — Numerigram, octobre 2026.
   Kbite la coche d'office et n'offre aucun réglage pour l'éviter. Or le
   consentement marketing doit venir d'un geste du visiteur (RGPD) : on la
   garde décochée tant que le visiteur n'y a pas touché lui-même. */
(function () {
  function decoche() {
    var f = document.querySelector('iframe.gw-modal');
    if (!f) return;
    var d;
    try { d = f.contentDocument || f.contentWindow.document; } catch (e) { return; }
    var c = d && d.getElementById('accepts_marketing');
    if (!c) return;
    if (!c.__sdoLie) {
      c.__sdoLie = true;
      c.addEventListener('change', function () { c.__sdoTouche = true; });
    }
    if (!c.__sdoTouche && c.checked) c.checked = false;
  }
  setInterval(decoche, 300);
})();

/* Arrivée depuis l'ajout rapide sur une variante épuisée (lien …?variant=X#sdo-notifier) :
   on ouvre directement la fenêtre d'alerte Kbite de la fiche. Numerigram, octobre 2026. */
(function () {
  if (location.hash !== '#sdo-notifier') return;
  var essais = 0;
  var t = setInterval(function () {
    var b = document.querySelector('.gw-button-widget');
    if (b && b.offsetParent && document.querySelector('iframe.gw-modal')) {
      clearInterval(t);
      b.scrollIntoView({ block: 'center' });
      b.click();
      try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
    } else if (++essais > 40) clearInterval(t);
  }, 250);
})();

/* Pied de page mobile en accordéons — Numerigram, octobre 2026.
   Sous 750 px, le thème masque les titres de rubrique et empile les trois listes
   (près de 80 liens). Chaque titre redevient visible et ouvre / ferme sa liste.
   Au-dessus de 750 px, rien ne change. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var css = document.createElement('style');
  css.textContent =
    '@media (max-width:749px){' +
    '.site-footer__item.sdo-acc{text-align:left}' +
    '.site-footer__item.sdo-acc .sdo-acc__titre{display:flex!important;align-items:center;justify-content:space-between;gap:12px;margin:0;padding:16px 2px;border-top:1px solid rgba(255,255,255,.16);font-size:13px;letter-spacing:.12em;text-transform:uppercase;cursor:pointer;-webkit-tap-highlight-color:transparent}' +
    '.site-footer__item.sdo-acc .sdo-acc__titre::after{content:"";flex:0 0 auto;width:7px;height:7px;margin:0 4px -2px 0;border:solid currentColor;border-width:0 1.5px 1.5px 0;transform:translateY(-3px) rotate(45deg);transition:transform .25s ease}' +
    '.site-footer__item.sdo-acc.est-ouvert .sdo-acc__titre::after{transform:translateY(1px) rotate(-135deg)}' +
    '.site-footer__item.sdo-acc .sdo-acc__titre:focus-visible{outline:1px solid #C99F33;outline-offset:2px}' +
    '.site-footer__item.sdo-acc .site-footer__linklist{display:none;margin:0;padding:0 2px 14px}' +
    '.site-footer__item.sdo-acc.est-ouvert .site-footer__linklist{display:block}' +
    '.site-footer__item.sdo-acc .site-footer__linklist li{text-align:left;margin:0!important;padding:0!important;line-height:1.3}' +
    '.site-footer__item.sdo-acc .site-footer__linklist a{display:block;padding:10px 0;margin:0}' +
    '.site-footer__item.sdo-acc--dernier{border-bottom:1px solid rgba(255,255,255,.16);margin-bottom:24px}' +
    '}';
  document.head.appendChild(css);

  var items = [];
  function prepare() {
    [].forEach.call(document.querySelectorAll('.site-footer__item'), function (it, i) {
      var titre = it.querySelector('.h4');
      var liste = it.querySelector('.site-footer__linklist');
      if (!titre || !liste || it.classList.contains('sdo-acc')) return;
      if (!liste.id) liste.id = 'sdo-acc-liste-' + i;
      it.classList.add('sdo-acc');
      titre.classList.add('sdo-acc__titre');
      titre.addEventListener('click', function () { if (mq.matches) bascule(it); });
      titre.addEventListener('keydown', function (e) {
        if (!mq.matches) return;
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); bascule(it); }
      });
      items.push(it);
    });
    if (items.length) items[items.length - 1].classList.add('sdo-acc--dernier');
    etat();
  }
  function bascule(it) {
    var ouvert = it.classList.toggle('est-ouvert');
    it.querySelector('.sdo-acc__titre').setAttribute('aria-expanded', ouvert ? 'true' : 'false');
  }
  /* Sur mobile, les titres se comportent comme des boutons ; sur ordinateur, ce sont des titres. */
  function etat() {
    items.forEach(function (it) {
      var t = it.querySelector('.sdo-acc__titre');
      var l = it.querySelector('.site-footer__linklist');
      if (mq.matches) {
        t.setAttribute('role', 'button');
        t.removeAttribute('aria-level'); /* 14/10/2026 : aria-level n'est pas permis sur un bouton */
        t.setAttribute('tabindex', '0');
        t.setAttribute('aria-controls', l.id);
        t.setAttribute('aria-expanded', it.classList.contains('est-ouvert') ? 'true' : 'false');
      } else {
        t.setAttribute('role', 'heading');
        t.setAttribute('aria-level', '2');
        t.removeAttribute('tabindex');
        t.removeAttribute('aria-controls');
        t.removeAttribute('aria-expanded');
      }
    });
  }
  if (mq.addEventListener) mq.addEventListener('change', etat); else if (mq.addListener) mq.addListener(etat);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepare); else prepare();
})();
